module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAAAXNSR0IArs4c6QAAATpJREFUOE/NkbEuREEUhr//XrfSSYhWq9B5AImIBHduI5HQ6WVV6IiGiqg8gAfYmURCg4LCC0gkOokKFYm1a46MrGSbtVua8s985/vPjEIIwcwW6H0uGo3GjLz3rzHGyRhjoxtTFEVhZlfArer1+jlwLGngD8kXsAyM/RiAJ0lZN8DMIjAKXCbDXlVVm71WCCFsmNlSMhw652p9ADvAXDIcVVW11gvw3u8Cs/8R8N4fOOfW+9hhW9J8eqV959xGH8AWsJiAN+AFyNtQ+qQXSUNm9pulnx6SdKoQwi1wJkkxRiSZmQ0Dz2lAlmWkwMymgPcE1MqyPOysFEK4K8tyvDPz3q8Ae6nSe5Zl061W6zNdyPN8JMa4muf5iaTHZrOZrAOSAnCdgBtgArD2xA8ze5A0Bgy2s9T4PtX6BjL4p81p+NW0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone.png
// module id = 5ng9
// module chunks = 2